import { jsx } from 'react/jsx-runtime';
import { useMemo, createContext, useContext } from 'react';

/**
 * Create Context.
 */ const Context = /*#__PURE__*/ createContext({
    isFlowComplete: false,
    isInteractive: true
});
/**
 * Vertical Stepper Provider.
 */ const VerticalStepperProvider = ({ children, ...rest })=>{
    /**
     * Memoize Provider Value.
     */ const value = useMemo(()=>rest, [
        rest
    ]);
    return jsx(Context.Provider, {
        value: value,
        children: children
    });
};
/**
 * Vertical stepper context hook.
 */ const useVerticalStepperContext = ()=>{
    return useContext(Context);
};

export { VerticalStepperProvider, useVerticalStepperContext };
//# sourceMappingURL=VerticalStepper.Context.es.js.map
